export type LanguageOption = {
  code: string;
  label: string;
};

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "zh", label: "Chinese (Simplified)" },
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "it", label: "Italian" },
  { code: "ru", label: "Russian" },
  { code: "ko", label: "Korean" },
  { code: "ja", label: "Japanese" },
  { code: "tr", label: "Turkish" },
  { code: "hi", label: "Hindi" },
  { code: "pt-BR", label: "Portuguese (Brazil)" },
  { code: "id", label: "Indonesian" },
  { code: "nl", label: "Dutch" },
  { code: "pl", label: "Polish" },
];
